export const LOAD_EXPOSURE_STARTED = "LOAD_EXPOSURE_STARTED";
export const LOAD_EXPOSURE_SUCCESS = "LOAD_EXPOSURE_SUCCESS";
export const COMPUTE_EXPOSURE_SUCCESS = "COMPUTE_EXPOSURE_SUCCESS";
export const RETRIEVE_EXPOSURE_CURRENCIES_SUCCESS = "RETRIEVE_EXPOSURE_CURRENCIES_SUCCESS";
